<template>
  <component
    :is="component_tag"
    class="arrow-text-hover"
    :class="{block: item_block}">
    <arrow-right-icon/>
    <span v-if="text">{{text}}</span>
  </component>
</template>

<script>
import ArrowRightIcon from "../icons/ArrowRightIcon.vue";

export default {
  name: "ArrowTextHover",
  components: {ArrowRightIcon},
  props: {
    component_tag: {
      type: String,
      default: 'span'
    },
    text: {
      type: String,
      default: ''
    },
    item_block: {
      type: Boolean,
      default: false
    },
  }
}
</script>
